import SearchLabTests from '@commons/categorySearch/search'
import SelectedLabTests from '@commons/categorySearch/selectedItems'
import Column from '@components/column'
const LabTest = ({ setFieldValue, values }) => {
  return (
    <Column rowGap={20}>
      <Column bg="white" styleColumn="padding:20px 15px;border-radius:8px;">
        <SearchLabTests
          setFieldValue={setFieldValue}
          selectedItems={values?.labTests}
          name="labTests"
          multiple={true}
          selector="labTestCategories"
          type="LabTest"
        />
      </Column>
      <Column bg="white" styleColumn="padding:20px 15px;border-radius:8px;">
        <SelectedLabTests
          selectedItems={values?.labTests}
          setFieldValue={setFieldValue}
          name="labTests"
          multiple={true}
          error=""
        />
      </Column>
    </Column>
  )
}

export default LabTest
